<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100000" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1300104">
        <ImportBtn
          title="客户导入"
          bizCodes="imp100041"
          fileUrl="/file/客户档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1002010101">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cmCustomerInfoBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          bizName="客户线路数据导出"
          bizCode="exp100048"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1300101">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'customerCode'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-if="scope.column.property === 'lineNumber'"
                  @click="toLine(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                  <!-- <span class="primary cur addLineBtn" @click="toLineEdit(scope.row.customerId)">新增</span> -->
                </section>
                <section v-if="scope.column.property === 'address'">
                  <el-tooltip
                    :content="scope.row[scope.column.property]"
                    v-if="scope.row.address.length > 7"
                  >
                    <span class="primary cur">
                      {{ scope.row.address.substr(0, 7) + '...' }}
                    </span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.address }}</span>
                  <!-- <span class="primary cur">{{scope.row[scope.column.property]}}</span> -->
                </section>
                <section
                  v-if="
                    scope.column.property !== 'customerCode' &&
                    scope.column.property !== 'lineNumber' &&
                    scope.column.property !== 'address'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1300103',
                    showCondition: scope.row.isAuth === 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '1300102',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row.customerId),
                  },
                  {
                    permpisions: '1300105',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                  {
                    permpisions: '1300201',
                    showCondition: true,
                    name: '新增线路',
                    event: () => toLineEdit(scope.row.customerId),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.customerId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  customerArchivesList, removeCustomerInfo,
} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'customerCode',
            label: '客户编码',
          },
          {
            prop: 'companyName',
            label: '客户全称',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'address',
            label: '客户地址',
            w: '150px',
          },
          {
            prop: 'lineNumber',
            label: '线路数',
          },
          {
            prop: 'stateString',
            label: '客户状态',
          },
          {
            prop: 'authStateString',
            label: '待审核状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerArchivesList,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核客户' : '客户详情',
        url: `/manage/archives/customer/archives/detail?id=${item.customerId}&type=${type}`,
      });
    },
    toLine (item) {
      this.jump({
        label: '线路档案',
        url: '/manage/archives/customer/line?companyName=' + item.companyName,
      });
    },
    toLineEdit (customerId) {
      this.jump({
        label: '新增线路',
        url: '/manage/archives/customer/line/edit?customerId=' + customerId,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '客户',
        url: `/manage/archives/customer/archives/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.customerName}】这个客户吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeCustomerInfo({
          customerId: item.customerId,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.addLineBtn {
  margin-left: 8px;
}
</style>
